import React, {FunctionComponent} from "react"
import { Portal as ReactPortal } from "react-portal";
import {ReactComponent as Close} from "../../Assets/Svg/cross.svg"
import "./modal.scss"
import Button from "../Button/Button";
type ModalProps = {
    isOpen: boolean,
    children: React.ReactNode,
    handleClose: () => void,
}


const Modal: FunctionComponent<ModalProps> = ({isOpen,children,handleClose}) =>{


    if(!isOpen){
        return null;
    }
    else{
        return (
            <ReactPortal>
                <div className="modal-background">
                    <div className="modal blur-background">
                        <div className="modal-header">
                            <Button className="close-btn" onClick={handleClose}><Close/></Button>
                        </div>
                        {children}
                    </div>
                </div>
            </ReactPortal>
        )
    }
}
export default Modal;